import { axiosIns } from 'config/api.config';
import { ENV } from 'config/ENV.config';

/**
 * Favorites (saved page shortcuts) live in portal-service (`public.shortcut_link`).
 * Call them through the Portal gateway, reusing axiosIns so the auth headers/interceptors apply.
 */
export const FavoriteService = {
  list: async (): Promise<any> =>
    await axiosIns.get('/shortcut-link/my', { baseURL: ENV.portalGetway }),

  add: async (payload: { name: string; path: string; icon?: string }): Promise<any> =>
    await axiosIns.post('/shortcut-link/save', payload, { baseURL: ENV.portalGetway }),

  remove: async (id: string): Promise<any> =>
    await axiosIns.delete('/shortcut-link/delete', { data: { id }, baseURL: ENV.portalGetway }),
};
